<template>
  <div id="app">
    <support v-if="isIE()"></support>
    <router-view v-else-if="isAlive" />
  </div>
</template>
<script>
import Support from './components/Support';
export default {
  provide() {
    return {
      reload: this.reload
    }
  },
  data: () => ({
    isAlive: true
  }),
  methods: {
    isIE() {
      const ua = navigator.userAgent;
      /* MSIE used to detect old browsers and Trident used to newer ones*/
      var is_ie = ua.indexOf('MSIE ') > -1 || ua.indexOf('Trident/') > -1;

      return is_ie;
    },
    reload() {
      this.isAlive = false;
      this.$nextTick(function () {
        this.isAlive = true;
      })
    }
  },
  components: {
    Support
  }
};
</script>
<style>
html {
  overflow: hidden;
}
</style>
